export const STRESS_EXERCISES = [
  {
    id: 'breathing',
    title: 'Дыхание 4-7-8',
    subtitle: '2–3 минуты · успокоение перед встречей',
  },
  {
    id: 'shoulders',
    title: 'Разгрузка плеч',
    subtitle: '3–4 минуты · снять напряжение от сидячей работы',
  },
  {
    id: 'grounding',
    title: 'Заземление 5-4-3-2-1',
    subtitle: '3–5 минут · вернуть внимание в настоящий момент',
  },
];

export const STRESS_DISCLAIMER =
  'Упражнения носят оздоровительный характер и не заменяют помощь специалиста.';

export const SHOULDER_STEPS = [
  { title: 'Круговые движения плечами', seconds: 30, hint: '8 медленных движений назад' },
  { title: 'Наклон головы к плечу', seconds: 40, hint: '20 секунд на каждую сторону' },
  { title: 'Растяжка рук вверх', seconds: 20, hint: 'Переплетите пальцы, ладони вверх' },
  { title: 'Мягкий поворот головы', seconds: 20, hint: 'Без боли, только комфортный диапазон' },
];

export const GROUNDING_STEPS = [
  '5 вещей, которые вы видите',
  '4 вещи, которые можете потрогать',
  '3 звука вокруг вас',
  '2 запаха (или 2 глубоких вдоха)',
  '1 медленный выдох и пауза',
];

export const BREATHING_PHASES = [
  { label: 'Вдох', seconds: 4 },
  { label: 'Задержка', seconds: 7 },
  { label: 'Выдох', seconds: 8 },
];
